import React from 'react'
import Navbar from '../Navbar'
import Footer from '../footer/Footer'
import bannerimg from '../../assets/images/bg.png'
import img1 from '../../assets/images/1.png'
import img2 from '../../assets/images/2.png'
import img3 from '../../assets/images/Arrow.png'

const Support = () => {
    return (
        <div>
            <Navbar />
            <div className='pt-3 innerBg'>
                {/* <img src={bannerimg} style={{ width: "100%" }}></img> */}
                <h1 style={{color:'white',fontWeight:'600'}}>Support 
                    {/* 8287551091 mbaguru@rootseducation.com */}
                    </h1>
            </div>
            <div className='py-5 my-3'>
                <div className='querycard'>
                    <h1 className='text-center'><strong>For General Assistance or Queries</strong></h1>
                    <div>
                        <div className='row py-5'>
                            <div className='col'>
                                <div className=' querycarddiv'>
                                    <div className='d-flex justify-content-between'>
                                        <div className='d-flex'>
                                            <img src={img1} width={50}></img>
                                            <p style={{padding:"10px 40px  0px"}}>Call Support</p>
                                        </div>
                                        <div  onClick={() => window.location.href = 'tel:8287551091'}>
                                            <img src={img3} width={50} style={{cursor:"pointer"}}></img>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='col'>
                                <div className=' querycarddiv'>
                                    <div className='d-flex justify-content-between'>
                                        <div className='d-flex'>
                                            <img src={img2} width={50}></img>
                                            <p style={{padding:"10px 40px  0px"}}>Send E-mail</p>
                                        </div>
                                        <div 
                                       onClick={() => {
                                        window.location.href = 'mailto:mbaguru@rootseducation.com?subject=Inquiry&body=Hi there, I have a question...';
                                      }}
                                        >
                                            <img src={img3} width={50} style={{cursor:"pointer"}}></img>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    )
}

export default Support
